'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).controller('goalEditCtrl', function ($scope, $rootScope, $window, $state, $http, $filter, MessageService, model, Goal) {
	var vm = this;

	var $translate = $filter('translate');

	vm.model = model;

	angular.extend($scope.$parent.vm, {
		title: 'goals.settings.title',
		insertUrl: null
	});

	$rootScope.laddaLoading = false;

	vm.save = function () {
		$rootScope.laddaLoading = true;


		if (!vm.model.goalId) {
			Goal.insert(vm.model, function () {
				$state.go('main.goal');
			}, function (response) {
				MessageService.alertError(response.data);
			});
		} else {
			Goal.update(vm.model, function () {
				$state.go('main.goal');
			}, function (response) {
				MessageService.alertError(response.data);
			});
		}
	}
});